module.exports = __webpack_public_path__ + "img/img-1.87fa32b7.jpg";